import styled from 'styled-components'

import { Flex } from 'app/components/design-system-components'
import { Text } from 'app/components/design-system-components/typography'
import theme from 'app/match/applicationReportPDF/assets/theme'
import CopyableText from 'app/shared_components/CopyableText'

const Label = styled(Text)`
  width: 25%;
  font-weight: ${theme.fontWeights.mid};
`

const Value = styled(Text)`
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

function DescComp({
  strongText = '',
  descText = '   ',
  isCopyAble = false,
}: {
  strongText?: string
  descText?: string
  isCopyAble?: boolean
}) {
  return (
    <Flex mb={5}>
      <Label as="span">{strongText}</Label>

      <Value as="span">
        {isCopyAble ? (
          <CopyableText text={descText} color="unset" />
        ) : (
          <>{descText}</>
        )}
      </Value>
    </Flex>
  )
}

export default DescComp
